import { useDroppable } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { cn, formatCurrency } from '@/lib/utils'
import { KanbanCard } from './KanbanCard'
import type { KanbanColumn as KanbanColumnType } from '@/types'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { useUIStore } from '@/stores/uiStore'

interface KanbanColumnProps {
  column: KanbanColumnType
}

export function KanbanColumn({ column }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: column.id,
  })

  const openModal = useUIStore((state) => state.openModal)

  const handleAddOpportunity = () => {
    openModal('create-opportunity', { stage: column.id })
  }

  return (
    <div
      className={cn(
        'kanban-column',
        isOver && 'ring-2 ring-primary ring-offset-2'
      )}
    >
      {/* Column Header */}
      <div className="flex items-center justify-between p-4 border-b">
        <div className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: column.color }}
          />
          <h3 className="font-semibold text-sm">{column.title}</h3>
          <span className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full">
            {column.count}
          </span>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8"
          onClick={handleAddOpportunity}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>

      {/* Column Stats */}
      <div className="px-4 py-2 border-b bg-muted/30">
        <p className="text-xs text-muted-foreground">
          Total: <span className="font-medium text-foreground">{formatCurrency(column.totalValue)}</span>
        </p>
      </div>

      {/* Cards Container — scroll interno por coluna */}
      <div
        ref={setNodeRef}
        className="flex-1 overflow-y-auto p-2 space-y-2"
      >
        <SortableContext
          items={column.opportunities.map((opp) => opp.id)}
          strategy={verticalListSortingStrategy}
        >
          {column.opportunities.map((opportunity) => (
            <KanbanCard key={opportunity.id} opportunity={opportunity} />
          ))}
        </SortableContext>

        {column.opportunities.length === 0 && (
          <div className="flex items-center justify-center h-24 text-muted-foreground text-sm border-2 border-dashed rounded-lg">
            Arraste cards aqui
          </div>
        )}
      </div>
    </div>
  )
}
